<template minapp='mpx' xlang='wxml'>
  <view class="es-content__tip">
    <view class="es-content__tip-radio" bindtap="handleRead">
      <checkbox-icon 
        size="{{14}}"
        checked="{{innerValue}}"
        class="es-content__check-box" 
        custom-class="es-content__check-box" 
      />
      <text>阅读并同意以下内容</text>
    </view>

    <view class="es-content__tip-text">
      {{tipText}}
    </view>
  </view>
</template>

<script>
import { watch } from "@mpxjs/core";
import store from '@/store'
import { createComponent } from '@didi/es-mpx-creator'
import { tipTextConfig } from '@/config/content/index'

createComponent({
  classes: [],
  data: {
    innerValue:false,
  },
  props: {
    value:{
      type: Boolean,
      value: false
    },
    category:{
      type: String,
      value: '',
    }
  },
  computed: {
    ...store.mapGetters({
      isExemption: 'makeOrder.isExemption',
    }),
    tipText(){
      const { appid } = this.$mpxRoute.query
      const isMini = ['121735', '2021004166617541'].includes(appid)
      return this.isExemption ? (isMini ? tipTextConfig['trainNoLoginMini'] : tipTextConfig['trainNoLogin']) : tipTextConfig[this.category]
    }
  },
  methods: {
    // 阅读提示
    handleRead() {
      this.innerValue = !this.innerValue
    },
  },
  watch:{
    value(val) {
      this.innerValue = val
    },
    //将数据回传
    innerValue(newValue) {
      this.$trigger( 'input', {value:newValue} )
    },
  }
})
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('tip')
      margin 0 12px 40px 12px
      background-color transparent
    +e('tip-radio')
      color #666666
      font-size 12px
      margin-bottom 4px
      display flex
      align-items center
    +e('check-box')
      margin-right 3px !important
      vertical-align middle !important
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'checkbox-icon': '../../checkbox-icon',
    }
  }
</script>

